import React, {useState, useEffect, useSearchParams} from "react";
import { useHistory } from "react-router-dom";

import { Autocomplete } from "@material-ui/lab";
import {Auth} from "aws-amplify";

import AddVariableRow from "../../components/AddVariableRow"
import { addVariable, getBuildingVariables, getEquipmentVariables, getSiteVariables, getSpaceVariables, getFeatureVariables } from "../../services/MetadataService";
import { getCollectionMethods, getPotentialVariables, getUnits } from "../../services/AirtableService";
import { TextField } from "@material-ui/core";
import useGlobal from "../../store"

const AddVariableForm = (props) => {
    let [potentialVariables, setPotentialVariables] = useState()
    let [existingVariables, setExistingVariables] = useState()
    let [inheritedVariables, setInheritedVariables] = useState()
    let [collectionMethods, setCollectionMethods] = useState()
    let [units, setUnits] = useState()

    let [selectedCollectionMethod, setSelectedCollectionMethod] = useState()
    let [currentUser, setCurrentUser] = useState()

    let [variables, setVariables] = useState({})

    let [successCount, setSuccessCount] = useState(0)
    let [failureCount, setFailureCount] = useState(0)
    let [currentState, currentActions] = useGlobal();

    let history = useHistory();

    useEffect(() => {
        async function fetchPotentialVars() {
            const potentialVars = await getPotentialVariables(props.context);
            setPotentialVariables(potentialVars);
        }
        fetchPotentialVars();
    }, [props.context])

    useEffect(() => {
        if (!collectionMethods) {
            setCollectionMethods(getCollectionMethods());
        }

        if (!existingVariables) {
            getVariableHistory()
        }

        if (!units) {
            setUnits(getUnits());
        }

        if (!currentUser) {
            Auth.currentUserInfo().then(response => {
                setCurrentUser(response.attributes.name)
            })
        }

    }, [])

    useEffect(() => {
        if (!inheritedVariables) {
            getInheritedValues()
        }
    }, [selectedCollectionMethod])

    const getVariableHistory = () => {

        if (props.context === "site") {
            getSiteVariables(props.id).then (response => {
                processHistoryVariables(response)
            })
        } else if (props.context === "space") {
            getSpaceVariables(props.id).then (response => {
                processHistoryVariables(response)
            })
        } else if (props.context === "building") {
            getBuildingVariables(props.id).then (response => {
                processHistoryVariables(response)
            })
        }  else if (props.context === "equipment") {
            getEquipmentVariables(props.id).then (response => {
                processHistoryVariables(response)
            })
        }  else if (props.context === "feature") {
            getFeatureVariables(props.id).then (response => {
                processHistoryVariables(response.variables)
            })
        }
    }

    //TODO: This needs cleanup but moving things ends up in a lot of eventing.  CLean this up later
    const getInheritedValues = () => {
        let historyMap = Object.assign({}, inheritedVariables);
        if (props.context === "building") {
            let site = currentState.site;
            if (site && site.site_id) {
                getSiteVariables(site.site_id).then (response => {
                    response.forEach(entry => {
                        if (!historyMap.name) {
                            let history = entry.variable_history;
                            if (history) {
                                let latest_value = history[0].value;
                                let units = history[0].unit;
                                historyMap[entry.name] = {
                                    value: latest_value,
                                    units: units
                                }
                            }
                        }
                    })
                })
            }
        }  else if (props.context === "space" || props.context === "feature") {
            let building = currentState.building;
            if (building && building.id) {
                getBuildingVariables(building.id).then (response => {
                    response.forEach(entry => {
                        if (!historyMap.name) {
                            let history = entry.variable_history;
                            if (history) {
                                let latest_value = history[0].value;
                                let units = history[0].unit;
                                historyMap[entry.name] = {
                                    value: latest_value,
                                    units: units
                                }
                            }
                        }
                    })

                    let site = currentState.site;
                    if (site && site.site_id) {
                        getSiteVariables(site.site_id).then (response => {
                            response.forEach(entry => {
                                if (!historyMap.name) {
                                    let history = entry.variable_history;
                                    if (history) {
                                        let latest_value = history[0].value;
                                        let units = history[0].unit;
                                        historyMap[entry.name] = {
                                            value: latest_value,
                                            units: units
                                        }
                                    }
                                }
                            })
                        })
                    }
                })
            }
        }
        setInheritedVariables(historyMap)
    }

    useEffect(() => {
        getInheritedValues();
    },[currentState.building, currentState.site, currentState.space])

    const processHistoryVariables = (vars) => {
        let historyMap = Object.assign({}, existingVariables);
        vars && vars.forEach(entry => {
            if (!historyMap.name) {
                let history = entry.variable_history;
                if (history) {
                    let latest_value = history[0].value;
                    let units = history[0].unit;
                    historyMap[entry.name] = {
                        value: latest_value,
                        units: units
                    }
                }
            }
        })
        setExistingVariables(historyMap)
    }

    const variableToAddCallback = (id, variable) => {
        if (!variable) return;
        let currentVariables = Object.assign({}, variables)
        currentVariables[id] = variable;

        setVariables(currentVariables)
        setSuccessCount(0)
        setFailureCount(0)
    }

    const submitAll = () => {
        let currentVariables = Object.assign([], variables)

        Object.keys(variables).forEach(i => {
            let v = variables[i]
            v.collection_method = selectedCollectionMethod
            v.collected_by = currentUser
            v.collection_date = new Date().toISOString().split('T')[0];

            if (!v.success && v.name && (v.value && v.value.length > 0) && v.collection_method_loe) {
                addVariable(v, props.context, props.id).then(response => {
                    currentVariables[i].success = true;
                    currentVariables[i].error = null;
                    setSuccessCount(successCount + 1);
                    setVariables(currentVariables);
                }).catch(err => {
                    console.log(err)
                    currentVariables[i].success = false;
                    setFailureCount(failureCount + 1);
                    currentVariables[i].error = "Variable was not added";
                    setVariables(currentVariables)
                })
            }
        })


    }

    const returnToElement= () => {
        if (props.context === "site") history.push("/locations/" + props.id)
        if (props.context === "building") history.push("/buildings/" + props.id)
        if (props.context === "space") history.push("/spaces/" + props.id)
        if (props.context === "equipment") history.push("/equipment/" + props.id)
        if (props.context === "feature") history.push("/features/" + props.id)
    }

    if (!collectionMethods || !potentialVariables) {
        return null;
    }

    let addRows = [];
    // TODO(mike): Sort by name in airtable api call
    potentialVariables.sort((a,b) => a.name.localeCompare(b.name))
    potentialVariables.forEach(p => {
        let current = variables[p.name]
        let variable = {
            variable_name: p.name,
            options: p.options,
            description: p.description,
            success: current && current.success,
            error: current && current.error,
            defaultValue: existingVariables && existingVariables[p.name],
            inheritedValue: inheritedVariables && inheritedVariables[p.name]
        }

        addRows.push(
            <AddVariableRow key={addRows.length} row_id={p.name} callback={variableToAddCallback} variable={variable} units={units} />
        )
    })

    return (
        <div className="layer3">
            <div className="bulk-add-form">
                <div className="form-field">
                    <Autocomplete
                        disablePortal
                        id="sites"
                        options={collectionMethods.sort((a,b) => a > b ? 1: -1) }
                        renderInput={(params) => <TextField {...params} label="Collection Method" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setSelectedCollectionMethod(newValue);
                        }}
                    />
                </div>


            {
                selectedCollectionMethod  ?
                <div className="add-container">
                    <div className="instructions">Enter variable values for each known item. Skip rows that don't apply or are unknown at this time.  Rows that are highlighted in red were previously entered for this particular element, while teal values have been inherited from a parent.  Any highlighted field should be validated with the new collection method, corrected, or removed (via the delete icon to the right) before submitting. </div>
                    {
                        addRows
                    }

                    <div className="form-buttons">
                        <div className="form-button-left" onClick={returnToElement}>
                            Return to {props.context}
                        </div>
                        <div className="form-button-right" onClick={submitAll}>Submit</div>
                        <div className="form-submit-results">
                            { successCount > 0 && failureCount > 0 ? successCount + " row(s) added, " + failureCount + " row(s) failed to add" :
                            successCount > 0 ? successCount + " row(s) added" :
                            failureCount > 0 ? failureCount + " row(s) failed to add" :
                            null
                            }
                        </div>
                    </div>
                </div> : null

            }


            </div>
        </div>

    )


}

export default AddVariableForm;